export default __webpack_public_path__ + "static/media/icon-partnership.be4aa26d.svg";